import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {updateIotDeviceData} from '../../../state/ducks/iotDevice/actions';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';

const DeviceManualSyncChecker = () => {
    const {device} = useSelector(makeSelectIotDeviceMergedWithConsumerProduct()) || {};
    const {isHolderConnected, manualSyncDisabledDate, manualSyncFailedAttempts} = device || {};

    useEffect(() => {
        // check if the holder is reinserted - clear manual sync data, if any
        if (isHolderConnected && (manualSyncDisabledDate || manualSyncFailedAttempts)) {
            dispatch(
                updateIotDeviceData({
                    device: {manualSyncDisabledDate: null, manualSyncFailedAttempts: null},
                })
            );
        }
    }, [isHolderConnected]);

    return null;
};

export default DeviceManualSyncChecker;
